const category = 'web_vip_pay'

// 支付埋点
interface Params {
  [key: string]: unknown;
}

const actions = {
  // 兑换码弹框展示
  web_gift_code_pop_show(p?: Params) {},
  // 兑换码弹框点击
  web_gift_code_pop_click(p?: Params) {},
  // 兑换成功上报
  web_gift_code_exchange_success(p?: Params) {},
  // 店铺引导页面展示
  store_guide_page_show(p?: Params) {},
  // 店铺引导页面点击
  store_guide_page_click(p?: Params) {},
}
export default new Proxy(actions, {
  get(target, key: keyof typeof actions) {
    return (params: Record<string, unknown>) => {
      window.stat(category, key, params)
    }
  },
})
